<router-outlet></router-outlet>

<div class="custom-overlay" *ngIf="showSpinner">
	<div class="center">
		<mat-spinner></mat-spinner>
	</div>
</div>
